import L from 'leaflet'
import 'leaflet.heat'
import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import PropTypes from 'prop-types'

export default function HeatmapLayer({ points }) {
  const map = useMap()

  useEffect(() => {
    if (!points || points.length === 0) return

    const heatPoints = points
      .map((incident) => {
        if (!incident?.coordinates || !incident.coordinates.includes(',')) {
          return null
        }
        const [lat, lng] = incident.coordinates
          .split(',')
          .map((v) => parseFloat(v.trim()))
        if (isNaN(lat) || isNaN(lng)) return null
        return [lat, lng, 1]
      })
      .filter(Boolean)

    if (heatPoints.length === 0) return

    const heatLayer = L.heatLayer(heatPoints, {
      radius: 30,
      blur: 15,
      maxZoom: 17,
      max: 1.0,
      minOpacity: 0.6,
      gradient: {
        0.0: '#0000ff',
        0.3: '#00ccff',
        0.5: '#00ff88',
        0.7: '#ffdd00',
        0.85: '#ff6600',
        1.0: '#ff0000'
      }
    })

    heatLayer.addTo(map)

    return () => {
      map.removeLayer(heatLayer)
    }
  }, [map, points])

  return null
}

HeatmapLayer.propTypes = {
  points: PropTypes.array
}